// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__aBomn","isCenter":"style_isCenter__sq0c5","header-btn":"style_header-btn__dQKOX","content":"style_content___YFZu","isMobile":"style_isMobile__N1okE"};